import { Svg } from '@repo/ui';

import ErrorBaseView, { ErrorBaseViewController } from '@/components/tax-refund/common/view/ErrorView/ErrorBaseView';

interface Props {
  onPrimaryButtonClick: () => void;
  footerClickEvent?: string;
}

const TemporaryError = ({ onPrimaryButtonClick, footerClickEvent }: Props) => {
  const errorBaseViewController: ErrorBaseViewController = {
    graphic: <Svg src="icg_exclamation-mark_md.svg" width={80} height={80} />,
    title: '일시적인 오류로\n환급액을 조회하지 못했어요',
    description: (
      <>
        이용에 불편을 드려 죄송합니다.
        <br />
        잠시 후 다시 시도해주세요.
      </>
    ),
    primaryButtonText: '다시 시도',
    onPrimaryButtonClick: onPrimaryButtonClick,
    primaryButtonVariant: 'filled-primary',
    footerClickEvent: footerClickEvent
  };

  return <ErrorBaseView viewController={errorBaseViewController} />;
};

export default TemporaryError;
